import React from 'react';
import styled from 'styled-components';

export default function Status(props) {
  return <Root {...props} />;
}

const Root = styled.div`
  position: relative;
  padding-left: 16px;
  ::after {
    content: ' ';
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 8px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 1;
    background-color: ${(props) => (props.active ? '#10B880' : '#D2D5D9')};
  }
`;
